import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=5cf06c70&scoped=true&"
import script from "./PageCreate.vue?vue&type=script&lang=js&"
export * from "./PageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf06c70",
  null
  
)

export default component.exports